var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWtsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.31 37.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bab64;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-wtsapp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo",
    "data-name": "WA Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.87,5.45A18.57,18.57,0,0,0,.16,18.57a18.38,18.38,0,0,0,2.48,9.28L0,37.48l9.85-2.59a18.54,18.54,0,0,0,8.87,2.26h0A18.57,18.57,0,0,0,31.87,5.45ZM18.73,34h0a15.48,15.48,0,0,1-7.86-2.15l-.57-.34L4.46,33.06,6,27.37l-.37-.59A15.44,15.44,0,1,1,18.73,34ZM27.2,22.46C26.74,22.23,24.46,21.1,24,21s-.73-.23-1,.23-1.2,1.51-1.47,1.82-.55.35-1,.12a13,13,0,0,1-3.73-2.31A14,14,0,0,1,14.2,17.6c-.28-.47,0-.72.2-1s.46-.54.7-.81a3.41,3.41,0,0,0,.46-.78.85.85,0,0,0,0-.81c-.12-.23-1-2.51-1.43-3.44s-.76-.79-1-.8l-.89,0a1.72,1.72,0,0,0-1.24.58,5.21,5.21,0,0,0-1.63,3.88,9.05,9.05,0,0,0,1.9,4.8c.23.3,3.27,5,7.93,7a26,26,0,0,0,2.64,1,6.43,6.43,0,0,0,2.93.18c.89-.13,2.74-1.12,3.13-2.2A3.82,3.82,0,0,0,28.09,23C28,22.81,27.67,22.69,27.2,22.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWtsapp);
export default __webpack_public_path__ + "static/media/icon-wtsapp.45cbfe3ea562610d26ab3c0aad816824.svg";
export { ForwardRef as ReactComponent };